import Instafeed from 'instafeed.js'
import Flickity from 'flickity'

export default function () {
  const accessToken = '41624791.e574cf6.07411904998a4c84a046fd3c67383287'
  const limit = 20

  // const template = `
  //   <a target="_blank" class="instagram__image" style="background-image: url('{{image}}')" href="{{link}}">
  //     <div class="instagram__overlay">
  //       <div class="instagram__text">{{caption}}</div>
  //       <div class="instagram__meta">
  //         <div class="instagram__likes">{{likes}}</div>
  //         <div class="instagram__comments">{{comments}}</div>
  //       </div>
  //     </div>
  //   </a>
  //   `
  const feed = new Instafeed({
    get: 'user',
    userId: window.instaUserId,
    accessToken,
    limit,
    template: window.instaTemplate,
    resolution: 'standard_resolution',
    after: function () {
      const flkty = new Flickity(document.getElementById(this.options.target), {
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        percentPosition: false
      })
    }
  })
  // feed.run()

  const flkty = new Flickity(document.getElementById('instafeed'), {
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    percentPosition: false
  })
}



// WEBPACK FOOTER //
// ./app/blocks/instagram/instagram.js